export default __webpack_public_path__ + "static/media/5.27df2ac3.jpg";